import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LanguageService } from './language.service';
import { ApplicationLanguages, VideoLanguages } from '../components/language/language';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private translations: any;
  constructor(private http: HttpClient, private langservice: LanguageService) { }

  getTranslation(): Observable<any> {
    let language = this.langservice.getCurretnLang();
    let fileName = 'en';

    switch (language) {
      case VideoLanguages.French:
        fileName = 'fr'
        break;
      case VideoLanguages.CanadianFrench:
        fileName = 'fr'
        break;
      case VideoLanguages.English:
        fileName = 'en'
        break;
      case VideoLanguages.Arabic:
        fileName = 'ar'
        break;
      case VideoLanguages.ChineseSimplified:
        fileName = 'zh-Hans'
        break;
      case VideoLanguages.ChineseTraditional:
        fileName = 'zh-Hant'
        break;
      case VideoLanguages.Persian:
        fileName = 'fa'
        break;
      case VideoLanguages.Punjabi:
        fileName = 'pa'
        break;

      default:
        fileName = 'en'
        break;
    }
    return this.http.get(`assets/i18n/${fileName}.json`);
  }


}
